import { render } from "./DelightfulDeal.vue?vue&type=template&id=65e069b8"
import script from "./DelightfulDeal.vue?vue&type=script&lang=js"
export * from "./DelightfulDeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__